// src/components/AuthEmailLinkHandler.jsx
import { useEffect } from "react";
import { auth } from "../firebase/firebase";
import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";

export default function AuthEmailLinkHandler() {
  useEffect(() => {
    const href = window.location.href;

    if (!isSignInWithEmailLink(auth, href)) return;

    (async () => {
      try {
        let email = window.localStorage.getItem("emailForSignIn");
        if (!email) {
          email = window.prompt("Confirm your email to complete sign-in") || "";
        }
        if (!email) return;

        await signInWithEmailLink(auth, email, href);
        window.localStorage.removeItem("emailForSignIn");

        window.history.replaceState({}, document.title, window.location.origin);
      } catch (e) {
        console.error("Email link sign-in failed:", e);
      }
    })();
  }, []);

  return null;
}
